import homeBT from "assets/mobile/icons/bottom-navigate/home.png";
import promotionBT from "assets/mobile/icons/bottom-navigate/promotion.png";
import revertBT from "assets/mobile/icons/bottom-navigate/revert.png";
import supportBT from "assets/mobile/icons/bottom-navigate/support.png";
import userBT from "assets/mobile/icons/bottom-navigate/user.png";

import { PATH, userPath } from "./path";

export interface BottomNavigateItem {
  id: string;
  name: string;
  icon: string;
  path: string;
}

const BOTTOM_NAVIGATE: BottomNavigateItem[] = [
  {
    id: "home",
    name: "Trang chủ",
    icon: homeBT,
    path: PATH.Home,
  },
  {
    id: "revert",
    name: "Hoàn trả",
    icon: revertBT,
    path: PATH.User.Refund,
  },
  {
    id: "promotion",
    name: "Khuyễn mãi",
    icon: promotionBT,
    path: PATH.Promotion,
  },
  {
    id: "support",
    name: "CSKH 24/7",
    icon: supportBT,
    path: "https://acv188.win/",
  },
];

export const BOTTOM_NAVIGATE_LOGGED = [
  ...BOTTOM_NAVIGATE,
  {
    id: "account",
    name: "Tài khoản",
    icon: userBT,
    path: userPath,
  },
];

export const BOTTOM_NAVIGATE_UNLOGGED = [
  ...BOTTOM_NAVIGATE,
  {
    id: "account",
    name: "Đăng nhập",
    icon: userBT,
    path: PATH.Account.login,
  },
];
